module.exports = __webpack_public_path__ + "static/img/IMG_20170902_114530.547eb508.jpg";